function base64urlEncode(buffer: Uint8Array): string {
  return btoa(String.fromCharCode(...buffer))
    .replace(/\+/g, '-')
    .replace(/\//g, '_')
    .replace(/=/g, '')
}

export function generateCodeVerifier(): string {
  const array = new Uint8Array(96)
  crypto.getRandomValues(array)
  return base64urlEncode(array)
}

export async function generateCodeChallenge(verifier: string): Promise<string> {
  const data = new TextEncoder().encode(verifier)
  const digest = await crypto.subtle.digest('SHA-256', data)
  return base64urlEncode(new Uint8Array(digest))
}

export async function generatePkceParams(clientId: string): Promise<{ codeChallenge: string; state: string }> {
  const verifier = generateCodeVerifier()
  const codeChallenge = await generateCodeChallenge(verifier)
  const state = crypto.randomUUID()
  sessionStorage.setItem('pkce_verifier', verifier)
  sessionStorage.setItem('pkce_state', state)
  sessionStorage.setItem('pkce_client_id', clientId)
  return { codeChallenge, state }
}

export function consumePkceParams(): { verifier: string; state: string; clientId: string } | null {
  const verifier = sessionStorage.getItem('pkce_verifier')
  const state = sessionStorage.getItem('pkce_state')
  const clientId = sessionStorage.getItem('pkce_client_id')
  if (!verifier || !state || !clientId) return null
  sessionStorage.removeItem('pkce_verifier')
  sessionStorage.removeItem('pkce_state')
  sessionStorage.removeItem('pkce_client_id')
  return { verifier, state, clientId }
}
